import DateFormat from '@/shared/utils/date-format'

export default class Validity {
  competenceStart: string;

  competenceEnd: string

  constructor(obj: any = {}) {
    this.competenceStart = obj.competenceStart || '';
    this.competenceEnd = obj.competenceEnd || '';
  }

  public static of(obj: any = {}): Validity {
    return new Validity(obj);
  }

  get validityText(): string {
    return `${DateFormat.localDateToLocal(this.competenceStart)} - ${DateFormat.localDateToLocal(this.competenceEnd)}`
  }
}
